import React, { useEffect } from 'react';
import ProBg from "./proBg.jpg"
const BoilerPlates = () => {
    useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top when this page loads
  }, []);
  return (

    <div>
      <section
        className="featured-job-area section-padding30 section-bg2"
        style={{
           backgroundImage: `url(${ProBg})`,  backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '400px',  // Adjust the height here
        }}
      >
        <div className="container">
          <div className="row justify-content">
            <div className="col-xl-7 col-lg-9 col-md-10 col-sm-12">
              {/* Section Title */}
              <div className="section-tittle text-left mb-80">
                <h2>Boiler plates </h2>
              </div>
            </div>
          </div>
          <div className="row justify-content-center">
            {/* Add content here */}
          </div>
        </div>
      </section>

      <section className="about-low-area section-padding2" style={{ marginTop: '-50px' }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-10">
              <div className="about-caption mb-11">
                <div className="section-tittle mb-11">
                  {/* <span>About Al Hadeed Steel</span> */}
                  {/* <h2>Building the Future with Strength and Durability</h2> */}
                </div>
                <p style={{lineHeight:"2.4"}}>
<h3>Boiler Quality Steel</h3>
<p style={{lineHeight:"2.4"}}>Boiler quality steel refers to a category of steels specifically designed for use in the construction of **boilers**, **pressure vessels**, and similar equipment that must withstand **high pressure**. These steels are engineered to provide the strength, durability, and resistance needed for such critical applications. When steel is described as **boiler quality**, it indicates its ability to endure the immense pressure encountered in various vessels, ensuring safety in operations involving volatile compounds. Without these materials, boilers and pressure vessels would not meet the required safety standards.</p>

<h3>Regulations and Standards</h3>
<p style={{lineHeight:"2.4"}}>The manufacture of **pressure vessels** is a highly regulated process due to the inherent dangers associated with the operation of these structures. Boilers and pressure vessels can act as extremely dangerous devices if they are not properly designed, fabricated, or maintained. Some of the primary regulatory sources include the EU’s **Pressure Equipment Directive** (PED), **PD5500**, the **National Board**, and the **ASME Pressure Vessel Code** in the US. Additionally, classification societies like **Lloyds**, **DNV**, and **TUV** certify both the **boiler quality steel plates** and the fabricated **pressure vessels**. In Europe, the main source of standards for boiler quality plates is **EN10028**, which covers a wide range of grades for pressure purposes. In the United States, the most common boiler quality steel standards are the **ASME/ASTM SA/A 516** and **ASME/ASTM SA/A387**. **EN10028** harmonizes the old national standards in the European Union, replacing older standards like **BS 1501** and **DIN 17155**. Other terms for boiler quality steel include **boiler plate**, **PV plate**, and **pressure vessel steel**.</p>

<h3>Uses of Boiler Quality Steel</h3>
<p style={{lineHeight:"2.4"}}>Boiler quality steel is crucial in various industrial processes, especially where **high pressure** and **temperature resistance** are required. In the **power generation** industry, it is used for heating water to generate **steam**, and it plays a vital role in large buildings for supplying both **hot water** and **heating**. In industries such as **food processing**, **chemical manufacturing**, and **pharmaceutical production**, boiler quality steel is used in reactors, pressure vessels, and other equipment that help transform raw materials into finished products. In the **oil and gas** industry, **boiler quality steel plate** is used for constructing pressure vessels, heat exchangers, **process modules**, and **skids**, as well as in large downstream facilities. Without boiler quality steel, it would be impossible to manufacture many everyday products, with its applications being particularly critical in industries like **palm oil processing** and **oil and gas refining**. Approximately **90% of supermarket products** rely on processes that involve boiler quality steel.</p>

 </p>
                
              </div>
            </div>
          </div>
               
        </div>
      </section>
    </div>
  );
}

export default BoilerPlates
;
 